import React, { Component } from "react";
import ReportHeader from "../Reports/Common/ReportHeader";
import ReportBody from "../Reports/Common/ReportBody";
import Input from "../2/Controls/Input";
import ReportButton from "../Reports/Common/ReportButton";
import Window from "../2/Controls/Window";
import Spinner from "../Common/Spinner";
import Pagination from "react-js-pagination";
import axios from "axios";
import * as constatnts from "../../Constatnts";

class ExpiryVerification extends Component {
  constructor() {
    super();
    this.state = {
      fromDate: null,
      toDate: null,
      verificationStatus: "pending",
      store: "",
      smartStoreList: [],
      approvalStatus: "Pending",
      selectedStoreID: "",
      records: [],
      showViewDetails: true,
      selectedRecord: null,
      from: 0,
      size: 50,
      loading: false,
      activePage: 1,
      paginationStatus: "No records to display",
      buttons: [],
      approvedAmountError: "",
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
    this.save = this.save.bind(this);
  }

  componentDidMount() {
    this.populateSmartStores();
    this.loadData(
      this.state.activePage,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      this.state.approvalStatus
    );
  }

  async loadData(
    page,
    size,
    storeID,
    fromDate1,
    toDate1,
    status,
    exportData = false
  ) {
    console.log("fromDate", fromDate1);
    console.log("toDate", toDate1);
    this.setState({ loading: true });
    let searchParameters = {
      index: "pincodeexpiryproducts",
      pageSize: size,
      page: page,
      fetchAll: exportData,
      query: {
        bool: {
          must: [],
        },
      },
    };
    if (storeID !== "") {
      searchParameters.query.bool.must.push({
        match: {
          StoreID: storeID,
        },
      });
    }
    if (status !== "") {
      searchParameters.query.bool.must.push({
        match: {
          ApprovalStatus: status,
        },
      });
    }
    if (fromDate1 && toDate1 && fromDate1 !== "" && toDate1 !== "") {
      //add date rqange
      const fromDateStr = fromDate1 + "T00:00:00";
      // Create a Date object
      console.log("fromDateStr", fromDateStr);
      const fromDate = new Date(fromDateStr);
      // Convert the Date object to epoch milliseconds
      const epochMillisFrom = fromDate.getTime();
      console.log("epochMillisFrom", epochMillisFrom);
      // Define the date-time string
      const toDateStr = toDate1 + "T23:59:59";
      // Create a Date object
      console.log("toDateStr", toDateStr);

      const toDate = new Date(toDateStr);
      // Convert the Date object to epoch milliseconds
      const epochMillisTo = toDate.getTime();
      console.log("epochMillisTo", epochMillisTo);

      searchParameters.query.bool.must.push({
        range: {
          TransactionDate: {
            // lte: searchTransactionToDate,
            // gte: searchTransactionFromDate,
            // format: "yyyy-MM-dd",
            lte: epochMillisTo,
            gte: epochMillisFrom,
          },
        },
      });
    }
    console.log("searchParameters", searchParameters);

    let totalItemsCount = 0;
    let records = [];
    //read data
    console.log("searchParameters", JSON.stringify(searchParameters));
    const response = await axios.post(
      "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/elastic/search/after",
      {
        ...searchParameters,
      }
    );
    console.log("response", response);
    if (
      response &&
      response.data &&
      response.data.data &&
      response.data.data.length > 0
    ) {
      totalItemsCount = response.data.total;
      response.data.data.map((data) => {
        if (exportData) {
          records.push({
            StoreID: data.StoreID,
            StoreName: data.StoreName,
            ProductID: data.ProductID,
            ProductName: data.ProductName,
            ProductSKU: data.ProductSKU,
            GID: data.GID,
            TransactionNo: data.TransactionNo,
            TransactionDate: new Date(data.TransactionDate)
              .toString()
              .substring(0, 24),
            Qty: data.Qty,
            ApprovedQty: data.ApprovedQty,
            ApprovedAmount: data.ApprovedAmount,
            Remarks: data.Remarks,
            ApprovalStatus: data.ApprovalStatus,
            TransactionCreatedBy: data.TransactionCreatedBy,
            AprrovalStatusUpdatedBy: data.AprrovalStatusUpdatedBy,
            AprrovalStatusUpdatedOn: new Date(data.AprrovalStatusUpdatedOn)
              .toString()
              .substring(0, 24),
            TransactionID: data.TransactionID,
            TransactionLineItemNo: data.TransactionLineItemNo,
            ExpiryDate: this.removeTimeFromISO(data.ExpiryDate),
            LotNo: data.LotNo,
          });
        } else {
          records.push(data);
        }
      });
    }
    if (exportData) {
      const csvData = constatnts.objToCSV(records);
      this.setState({ loading: false });
      const csvBlob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "expiry_report.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return;
    }
    this.setState({
      records: records,
      totalItemsCount: totalItemsCount,
      loading: false,
    });
    this.showPaginationStatus(totalItemsCount, Number(page - 1) * Number(size));
    // return;
    // let addMessage = firebase.functions().httpsCallable("scrollData");
    // let result = await addMessage({
    //   collection: "pincodeexpiryproducts",
    //   scrollID: "",
    //   text: searchParameters,
    // });
    // let sanitizedMessage = result.data.text;
    // sanitizedMessage.hits.hits.map((r, index) => {
    //   let data = r._source;
    //   if (exportData) {
    //     records.push({
    //       StoreID: data.StoreID,
    //       StoreName: data.StoreName,
    //       ProductID: data.ProductID,
    //       ProductName: data.ProductName,
    //       ProductSKU: data.ProductSKU,
    //       GID: data.GID,
    //       TransactionNo: data.TransactionNo,
    //       TransactionDate: new Date(data.TransactionDate)
    //         .toString()
    //         .substring(0, 24),
    //       Qty: data.Qty,
    //       ApprovedQty: data.ApprovedQty,
    //       ApprovedAmount: data.ApprovedAmount,
    //       Remarks: data.Remarks,
    //       ApprovalStatus: data.ApprovalStatus,
    //       TransactionCreatedBy: data.TransactionCreatedBy,
    //       AprrovalStatusUpdatedBy: data.AprrovalStatusUpdatedBy,
    //       AprrovalStatusUpdatedOn: this.removeTimeFromISO(
    //         data.AprrovalStatusUpdatedOn
    //       ),
    //       TransactionID: data.TransactionID,
    //       TransactionLineItemNo: data.TransactionLineItemNo,
    //       ExpiryDate: data.ExpiryDate,
    //       LotNo: data.LotNo,
    //     });
    //   } else {
    //     records.push({ key: r._id, ...r._source });
    //   }
    // });
    // totalItemsCount = sanitizedMessage.hits.total.value;

    // if (exportData) {
    //   let scrollID = sanitizedMessage._scroll_id;
    //   searchParameters = {
    //     scroll: "1m",
    //     scroll_id: scrollID,
    //   };
    //   for (let index = 1; index < totalItemsCount / size; index++) {
    //     let addMessage = firebase.functions().httpsCallable("scrollData");
    //     let result = await addMessage({
    //       text: searchParameters,
    //       scrollID: scrollID,
    //     });
    //     // console.log('result', result)
    //     let sanitizedMessage = result.data.text;
    //     sanitizedMessage.hits.hits.map((r, index) => {
    //       let data = r._source;
    //       if (exportData) {
    //         records.push({
    //           StoreID: data.StoreID,
    //           StoreName: data.StoreName,
    //           ProductID: data.ProductID,
    //           ProductName: data.ProductName,
    //           ProductSKU: data.ProductSKU,
    //           GID: data.GID,
    //           TransactionNo: data.TransactionNo,
    //           TransactionDate: new Date(data.TransactionDate)
    //             .toString()
    //             .substring(0, 24),
    //           Qty: data.Qty,
    //           ApprovedQty: data.ApprovedQty,
    //           ApprovedAmount: data.ApprovedAmount,
    //           Remarks: data.Remarks,
    //           ApprovalStatus: data.ApprovalStatus,
    //           TransactionCreatedBy: data.TransactionCreatedBy,
    //           AprrovalStatusUpdatedBy: data.AprrovalStatusUpdatedBy,
    //           AprrovalStatusUpdatedOn: this.removeTimeFromISO(
    //             data.AprrovalStatusUpdatedOn
    //           ),
    //           TransactionID: data.TransactionID,
    //           TransactionLineItemNo: data.TransactionLineItemNo,
    //           ExpiryDate: data.ExpiryDate,
    //           LotNo: data.LotNo,
    //         });
    //       } else {
    //         records.push({ key: r._id, ...r._source });
    //       }
    //     });
    //   }
    //   const csvData = constatnts.objToCSV(records);
    //   this.setState({ loading: false });
    //   const csvBlob = new Blob([csvData], { type: "text/csv" });
    //   const url = window.URL.createObjectURL(csvBlob);
    //   const a = document.createElement("a");
    //   a.setAttribute("hidden", "");
    //   a.setAttribute("href", url);
    //   a.setAttribute("download", "expiry_report.csv");
    //   document.body.appendChild(a);
    //   a.click();
    //   document.body.removeChild(a);
    //   return;
    // }

    // this.setState({
    //   records: records,
    //   totalItemsCount: totalItemsCount,
    //   loading: false,
    // });
    // this.showPaginationStatus(totalItemsCount, Number(page) * Number(size));
  }

  //PincodeServiceProviderID
  async populateSmartStores() {
    let registrations = await this.props.getPincodeSmartRegistrations();
    let tmp = await this.props.getPincodeStores(registrations);
    console.log("tmp", tmp);

    let smartStores = [];
    if (tmp && tmp.searchResult && tmp.searchResult.length > 0) {
      tmp.searchResult.map((s) => {
        if (
          s.PincodeServiceProviderID &&
          s.PincodeServiceProviderID.trim() !== ""
        ) {
          smartStores.push(s);
        }
      });
    }
    // console.log("registrations", registrations);
    // console.log("smartStores", smartStores);
    this.setState({ smartStoreList: smartStores });
  }

  async save(record) {
    this.setState({ saving: true });
    console.log("record", record);
    const response = await axios.put(
      "https://pincodebackgroundprocess-706168875042.asia-south1.run.app/update/expiry/products/" +
        record.id,
      {
        ...record,
      }
    );

    setTimeout(
      function() {
        //Start the timer
        this.loadData(
          this.state.pageNumber,
          this.state.size,
          this.state.selectedStoreID,
          this.state.fromDate,
          this.state.toDate,
          this.state.approvalStatus
        );
        this.setState({
          showViewDetails: false,
          approvedAmountError: "",
          saving: false,
        });
      }.bind(this),
      3000
    );
  }

  showPaginationStatus(totalItemsCount, recordFrom) {
    let paginationStatus;
    if (totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (recordFrom + 1 === totalItemsCount) {
      paginationStatus =
        "Showing " + totalItemsCount + " of " + totalItemsCount;
    } else if (recordFrom + this.state.size + 1 > totalItemsCount) {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        totalItemsCount +
        " of " +
        totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (recordFrom + 1) +
        " to  " +
        (recordFrom + this.state.size) +
        " of " +
        totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  removeTimeFromISO(dateStr) {
    if (!dateStr) return dateStr;

    // Check if time component exists
    if (dateStr.includes("T")) {
      return dateStr.split("T")[0]; // keep only YYYY-MM-DD
    }

    return dateStr; // already clean
  }

  handlePageChange(pageNumber) {
    // console.log("pageNumber", pageNumber);
    // console.log("this.state.size", this.state.size);
    // let recordFrom = (pageNumber - 1) * this.state.size;
    // console.log("recordFrom", recordFrom);
    this.setState({ activePage: pageNumber });
    this.loadData(
      pageNumber,
      this.state.size,
      this.state.selectedStoreID,
      this.state.fromDate,
      this.state.toDate,
      this.state.approvalStatus
    );
  }

  renderViewDetails() {
    return (
      <Window
        header={"View Expiry Details"}
        height={"400px"}
        width={"500px"}
        processing={this.state.saving}
        onClose={() => this.setState({ showViewDetails: false })}
        onButtonClick={async (buttonType) => {
          if (buttonType.toLowerCase() === "save") {
            let selectedRecord = this.state.selectedRecord;
            //ask for confirmation
            if (
              Number(selectedRecord.ApprovedQty) === Number(selectedRecord.Qty)
            ) {
              selectedRecord.ApprovalStatus = "Approved";
            } else if (Number(selectedRecord.ApprovedQty) === 0) {
              selectedRecord.ApprovalStatus = "Rejected";
            } else if (
              Number(selectedRecord.ApprovedQty) < Number(selectedRecord.Qty)
            ) {
              selectedRecord.ApprovalStatus = "Partially Approved";
            }
            selectedRecord.AprrovalStatusUpdatedBy = this.props.user.user.Name;
            selectedRecord.AprrovalStatusUpdatedOn = new Date().getTime();
            // if (
            //   selectedRecord.ApprovalStatus !== "Rejected" &&
            //   Number(selectedRecord.ApprovedAmount) === 0
            // ) {
            //   this.setState({
            //     approvedAmountError: "Please provide approved amount",
            //   });
            //   return;
            // }
            if (!window.confirm("Are you sure you wish to save this record?")) {
              // proceed
              return;
            }
            await this.save(selectedRecord);
            //push record to db
            console.log("selectedRecord", selectedRecord);
          } else {
            this.setState({ showViewDetails: false, approvedAmountError: "" });
          }
        }}
        buttons={this.state.buttons}
      >
        <div className="row">
          <div className="col-md-12">
            <Input
              type="text"
              label="Store"
              value={this.state.selectedRecord.StoreName}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="Transaction No"
              value={this.state.selectedRecord.TransactionNo}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label="Transaction Date"
              value={new Date(this.state.selectedRecord.TransactionDate)
                .toString()
                .substring(0, 24)}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Input
              type="text"
              label="Product"
              value={this.state.selectedRecord.ProductName}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="SKU"
              value={this.state.selectedRecord.ProductSKU}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label="GID"
              value={this.state.selectedRecord.GID}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="Expiry Date"
              value={this.removeTimeFromISO(
                this.state.selectedRecord.ExpiryDate
              )}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label="Lot No"
              value={this.state.selectedRecord.LotNo}
              disabled={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="Expired Qty"
              value={this.state.selectedRecord.Qty}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="number"
              label="Approved Qty"
              value={this.state.selectedRecord.ApprovedQty}
              onChange={(value) => {
                if (value < 0) {
                  value = "";
                  // return;
                }

                let selectedRecord = this.state.selectedRecord;
                if (Number(value) > Number(selectedRecord.Qty)) {
                  return;
                }
                selectedRecord.ApprovedQty = value;
                if (Number(value) === Number(selectedRecord.Qty)) {
                  selectedRecord.ApprovalStatus = "Approved";
                } else if (Number(value) === 0) {
                  selectedRecord.ApprovalStatus = "Rejected";
                  selectedRecord.ApprovedAmount = 0;
                } else if (Number(value) < Number(selectedRecord.Qty)) {
                  selectedRecord.ApprovalStatus = "Partially Approved";
                }
                this.setState({ selectedRecord: selectedRecord });
              }}
            />
          </div>
        </div>
        {/* {this.state.selectedRecord.ApprovedQty > 0 && (
          <div className="row">
            <div className="col-md-6">
              <Input
                type="number"
                label="Approved Amount"
                onChange={(value) => {
                  let selectedRecord = this.state.selectedRecord;
                  selectedRecord.ApprovedAmount = Number(value);
                  this.setState({
                    selectedRecord: selectedRecord,
                    approvedAmountError: "",
                  });
                }}
                value={this.state.selectedRecord.ApprovedAmount}
                error={this.state.approvedAmountError}
              />
            </div>
          </div>
        )} */}
        <div className="row">
          <div className="col-md-6">
            <Input
              type="text"
              label="Status"
              value={this.state.selectedRecord.ApprovalStatus}
              disabled={true}
            />
          </div>
          <div className="col-md-6">
            <Input
              type="text"
              label="Remarks"
              onChange={(value) => {
                let selectedRecord = this.state.selectedRecord;
                selectedRecord.Remarks = value;
                this.setState({ selectedRecord: selectedRecord });
              }}
              value={this.state.selectedRecord.Remarks}
            />
          </div>
        </div>
        <div className="row">
          {this.state.selectedRecord.Attachments &&
            this.state.selectedRecord.Attachments.map((attachment, index) => (
              <div className="col-md-6">
                <div className="pincode-product-image">
                  <div className="pincode-product-image-img">
                    <img src={attachment.Path} alt="Attachment" />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Window>
    );
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <ReportHeader
            title={"Expiry Verification"}
            showBack={true}
            onBack={() => {
              console.log("back clicked");
              this.props.history.push({ pathname: "/home/" });
            }}
          ></ReportHeader>
          <ReportBody>
            <div className="row">
              <div className="col-md-2">
                <Input
                  type="date"
                  label="From Date"
                  value={this.state.fromDate}
                  onChange={(value) => this.setState({ fromDate: value })}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="date"
                  label="To Date"
                  value={this.state.toDate}
                  onChange={(value) => this.setState({ toDate: value })}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Store"
                  value={this.state.selectedStoreID}
                  onChange={(value) =>
                    this.setState({ selectedStoreID: value })
                  }
                >
                  <option value="">All</option>
                  {this.state.smartStoreList.map((s) => (
                    <option value={s.key}>{s.StoreName}</option>
                  ))}
                </Input>
              </div>
              <div className="col-md-2">
                <Input
                  type="select"
                  label="Status"
                  value={this.state.approvalStatus}
                  onChange={(value) => this.setState({ approvalStatus: value })}
                >
                  <option value="">All</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Partially Approved">Partially Approved</option>
                  <option value="Rejected">Rejected</option>
                </Input>
              </div>
              <div className="col-md-4">
                <ReportButton
                  type="search"
                  onClick={() => {
                    this.loadData(
                      1,
                      this.state.size,
                      this.state.selectedStoreID,
                      this.state.fromDate,
                      this.state.toDate,
                      this.state.approvalStatus
                    );
                  }}
                />
                <ReportButton
                  type="clear"
                  onClick={() => {
                    this.setState({
                      from: 1,
                      size: this.state.size,
                      selectedStoreID: "",
                      fromDate: null,
                      toDate: null,
                      approvalStatus: "Pending",
                    });
                    this.loadData(0, 50, "", null, null, "Pending");
                  }}
                />
                <ReportButton
                  type="export"
                  onClick={() =>
                    this.loadData(
                      this.state.activePagefrecordFrom,
                      this.state.size,
                      this.state.selectedStoreID,
                      this.state.fromDate,
                      this.state.toDate,
                      this.state.approvalStatus,
                      true
                    )
                  }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {this.state.loading && <Spinner />}
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Store Name</th>
                      <th>Transaction No</th>
                      <th>Transaction Date</th>
                      <th>Product</th>
                      <th>Expiry Date</th>
                      <th>Qty</th>
                      <th>Qty Approved</th>
                      {/* <th>Amount</th> */}
                      <th>Status</th>
                      <th sttyle={{ width: "100px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.records.map((record) => (
                      <tr>
                        <td>{record.StoreName}</td>
                        <td>{record.TransactionNo}</td>
                        <td>
                          {new Date(record.TransactionDate)
                            .toString()
                            .substring(0, 24)}
                        </td>
                        <td>
                          <div>{record.ProductName}</div>
                          <div>{record.ProductSKU}</div>
                          <div>{record.GID}</div>
                        </td>
                        <td>
                          <div>{this.removeTimeFromISO(record.ExpiryDate)}</div>
                          {record.LotNo && <div>{record.LotNo}</div>}
                        </td>
                        <td style={{ textAlign: "right" }}>{record.Qty}</td>
                        <td style={{ textAlign: "right" }}>
                          {record.ApprovedQty}
                        </td>
                        {/* <td style={{ textAlign: "right" }}>
                          {record.ApprovedAmount}
                        </td> */}
                        <td>{record.ApprovalStatus}</td>
                        <td>
                          <a
                            onClick={() => {
                              let buttons = [];
                              if (record.ApprovalStatus === "Pending") {
                                buttons = [
                                  {
                                    Type: "secondary",
                                    Text: "Cancel",
                                    Align: "left",
                                  },
                                  {
                                    Type: "primary",
                                    Text: "Save",
                                    Align: "right",
                                  },
                                ];
                              }
                              this.setState({
                                selectedRecord: record,
                                showViewDetails: true,
                                buttons: buttons,
                              });
                            }}
                          >
                            View
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {this.state.totalItemsCount > 0 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="pull-left" style={{ marginTop: "25px" }}>
                    {this.state.paginationStatus}
                  </div>
                  <div className="pull-right">
                    <Pagination
                      activePage={this.state.activePage} //this.state.activePage
                      itemsCountPerPage={this.state.size}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={2}
                      onChange={this.handlePageChange}
                    />
                  </div>
                </div>
              </div>
            )}
          </ReportBody>
          {/* store wise pending approval summary */}
          {this.state.showViewDetails &&
            this.state.selectedRecord &&
            this.renderViewDetails()}
        </section>
      </div>
    );
  }
}

export default ExpiryVerification;
